import { render, staticRenderFns } from "./NewMatchMessage.vue?vue&type=template&id=5ba7e29f&"
import script from "./NewMatchMessage.vue?vue&type=script&lang=js&"
export * from "./NewMatchMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports